export const NAME = 'addToHomeScreen';

export const allowedMobileBrowserRoutes = ['/twitter-auth', '/confirm-email'];
